/**
 * shareDataEditModule 租户共享数据配置弹窗
 * Author: Qian.qianchen 2019-07-16
 */

"use strict";
angular.module("shareDataEditModule", [])
    .controller("shareDataEditCtrl", ["$scope", "trsHttpService", "$state", "$modalInstance", "tenantId", "product", "trsspliceString", "$q", "$validation", "$element", "$filter", "modalDialog", function($scope, trsHttpService, $state, $modalInstance, tenantId, product, trsspliceString, $q, $validation, $element, $filter, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                product: product,
                tenantId: tenantId,
            }
            $scope.data = {
                selectedShare: 0
            }
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            $scope.data.tenantList = [];
            getRuleDetail().then(() => {
                $scope.data.filterList = $scope.data.filterList.map((_item) => {
                    _item.TENANTUSERS = trsspliceString.spliceString(_item.Tenants, "TenantName", "、");
                    return _item;
                });
            });
        }
        /**
         * [getRuleDetail description] 获取共享规则详情
         * @return {[type]} [description]
         */
        function getRuleDetail() {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_tenantdatadivide',
                methodname: 'queryRelByProductId',
                ProductId: $scope.status.product.MEDIA_ID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                $scope.shareSelect(data.SHARETYPE);
                $scope.data.filterList = data.SHARETYPE == 1 ? data.TENANTINFO : [];
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [getTenants description] 获取全部租户
         * @return {[type]} [description]
         */
        function getTenants() {
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_tenantdatadivide',
                methodname: 'queryInuseTenants',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                $scope.data.tenantList = data.filter((_item) => {
                    return _item.TENANTID != $scope.status.tenantId;
                });
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [getFilter description] 获取筛选条件数据
         * @return {[type]} [description]
         */
        function getFilter() {
            for (let i = 0; i < $scope.data.filterList.length; i++) {
                if ($scope.data.filterList[i].ID == $scope.data.selectedFilter.ID) {
                    return $scope.data.filterList[i];
                }
            }
        }
        /**
         * [formatFilter description] 筛选条件格式化
         * @return {[type]} [description]
         */
        function formatFilter() {
            let filterArray = angular.copy($scope.data.filterList);
            filterArray.map((_item) => {
                _item.Tenants.map((_user) => {
                    _user.TenantId = parseInt(_user.TenantId);
                });
                _item.BeginDate = $filter('date')(_item.BeginDate, 'yyyy-MM');
                _item.EndDate = $filter('date')(_item.EndDate, 'yyyy-MM');
            });
            return JSON.stringify(filterArray);
        }

        /**
         * [shareSelect description] 共享类型切换
         * @param  {[type]} shareType [description] 共享类型
         * @return {[type]}           [description]
         */
        $scope.shareSelect = function(shareType) {
            $scope.data.selectedShare = shareType;
            if (shareType == 1) {
                $('.share_data_edit_container').find('.modal-dialog').css({ width: '1022px', height: '506px' });
                getTenants();
            } else {
                $('.share_data_edit_container').find('.modal-dialog').css({ width: '446px', height: '312px' });
            }
        }
        /**
         * [isChecked description] 判断该租户是否被选中
         * @param  {[type]}  tenant [description]
         * @return {Boolean}        [description]
         */
        $scope.isChecked = function(tenant) {
            if ($scope.data.filterList.length > 0) {
                let isChecked = false;
                for (let i = 0; i < $scope.data.filterList.length; i++) {
                    if ($scope.data.filterList[i].Tenants.some((_item) => {
                            return _item.TenantId == tenant.TENANTID;
                        })) {
                        return true;
                    }
                }
            }
            return false;
        }
        /**
         * [isDisabled description] 是否禁止可点
         * @param  {[type]}  tenant [description] 租户对象
         * @return {Boolean}        [description]
         */
        $scope.isDisabled = function(tenant) {
            if (angular.isUndefined($scope.data.selectedFilter)) {
                return true;
            }
            if (!$scope.isChecked(tenant)) {
                return false;
            }
            return $scope.data.selectedFilter.Tenants.every((_item) => {
                return _item.TenantId != tenant.TENANTID;
            });
        }
        /**
         * [chooseItem description] 选择/取消选择
         * @param  {[type]} item [description] 租户
         * @return {[type]}      [description]
         */
        $scope.chooseItem = function(item) {
            if (!$scope.isChecked(item)) {
                $scope.data.selectedFilter.Tenants.push({ TenantId: item.TENANTID, TenantName: item.TENANTNAME });
            } else {
                $scope.data.selectedFilter.Tenants = $scope.data.selectedFilter.Tenants.filter((_item) => {
                    return _item.TenantId != item.TENANTID
                });
            }
            $scope.data.selectedFilter.TENANTUSERS = trsspliceString.spliceString($scope.data.selectedFilter.Tenants, "TenantName", "、");
        }
        /**
         * [isSelectedAll description] 判断是否全部选中
         * @return {Boolean} [description]
         */
        $scope.isSelectedAll = function() {
            return $scope.data.tenantList.every((_item) => {
                return $scope.isChecked(_item);
            })
        }
        /**
         * [chooseAll description] 全选/全不选
         * @return {[type]} [description]
         */
        $scope.chooseAll = function() {
            if ($scope.isSelectedAll()) {
                $scope.data.selectedFilter.Tenants = [];
            } else {
                angular.forEach($scope.data.tenantList, (item, index) => {
                    if (!$scope.isChecked(item)) {
                        $scope.data.selectedFilter.Tenants.push({ TenantId: item.TENANTID, TenantName: item.TENANTNAME });
                    }
                });
            }
            $scope.data.selectedFilter.TENANTUSERS = trsspliceString.spliceString($scope.data.selectedFilter.Tenants, "TenantName", "、");
        }
        /**
         * [deleteFilter description] 删除筛选条件
         * @param  {[type]} filter [description] 筛选条件
         * @return {[type]}        [description]
         */
        $scope.deleteFilter = function(index, filter) {
            modalDialog.alertType('', '确定删除数据配置条目？', 'info', true, () => {
                if (filter == $scope.data.selectedFilter) {
                    delete $scope.data.selectedFilter;
                }
                $scope.data.filterList.splice(index, 1);
            });
        }
        /**
         * [addFilter description] 添加筛选条件
         */
        $scope.addFilter = function() {
            let nowDate = new Date();
            $scope.data.filterList.unshift({ Tenants: [], BeginDate: $filter('date')(nowDate, 'yyyy-MM'), EndDate: $filter('date')(new Date(nowDate.getFullYear() + "-" + (nowDate.getMonth() + 2)), 'yyyy-MM') });
            $scope.data.selectedFilter = $scope.data.filterList[0];
        }
        /**
         * [isError description] 是否错误
         * @param  {[type]}  index [description]
         * @return {Boolean}       [description]
         */
        $scope.isError = function(index) {
            if (angular.isDefined($scope.shareForm.$error['tenant_' + index]) || angular.isDefined($scope.shareForm.$error['startTime_' + index]) || angular.isDefined($scope.shareForm.$error['endTime_' + index])) {
                return true;
            }
            return false;
        }
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        }
        /**
         * [confirm description] 保存
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            let defer = $q.defer();
            $scope.shareForm.$pending = {};
            $validation.validate($scope.shareForm)
                .success(function() {
                    let params = {
                        serviceid: "mlf_tenantdatadivide",
                        methodname: "saveProductTenantRel",
                        ProductId: $scope.status.product.MEDIA_ID,
                        ProductName: $scope.status.product.NAME,
                        ShareType: $scope.data.selectedShare,
                        MediaType: $scope.status.product.CHANNEL_TYPE,
                        TenantInfo: $scope.data.selectedShare == 1 ? formatFilter() : ""
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        $modalInstance.close();
                        defer.resolve();
                    });
                }).error(function(msg) {
                    angular.invalidPosition($scope.shareForm, $element);
                    defer.reject();
                });
            return defer.promise;
        }
    }]);